import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import YourReviews from './YourReviews';
import Link from '../Link';

import messages from '../../locale/messages';
import { debounce } from '../../helpers/debounce';

import { LinkIndicateIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';
import s from './Reviews.css';

const Reviews = ({
  reviewsData,
  loadMore,
  type,
  isReviewLoading,
  intl: { formatMessage }
}) => {
  const [current, setCurrent] = useState('responded');
  const [searchKey, setSearchKey] = useState('');

  const handleClick = useCallback((ownerType, selectedCurrent) => {
    const { refetch } = reviewsData;
    const variables = { ownerType, offset: 0, current: selectedCurrent };
    setCurrent(selectedCurrent);
    refetch(variables);
  }, [reviewsData]);

  const handleSearchChange = useCallback(debounce((value) => {
    const { refetch } = reviewsData;
    const variables = {
      searchKey: value,
      current,
      type: 'others'
    };
    setSearchKey(value);
    refetch(variables);
  }), [current, reviewsData]);

  const { userReviews } = reviewsData || {};

  return (
    <div className={cx('reviews', s.reviewPanel)}>
      <ul className={cx('list-inline', s.tabs, 'tabsRTL')}>
        <li className={current === 'responded' ? s.active : ''}>
          <a className={cx(s.tabItem)} onClick={() => handleClick('others', 'responded')}>
            <FormattedMessage {...messages.responded} />
          </a>
        </li>
        <li className={current === 'notResponded' ? s.active : ''}>
          <a
            className={cx(s.tabItem)}
            onClick={() => userReviews?.results && handleClick('others', 'notResponded')}
          >
            <FormattedMessage {...messages.notResponded} />
          </a>
        </li>
        <li className={cx(s.reviewEditProfile, 'reviewEditProfileRTL')}>
          <Link to="/user/edit">
            <FormattedMessage {...messages.editProfile} />
            <LinkIndicateIcon className={cx(s.editProfileArrow, 'editProfileArrowRTL')} alt="arrow" />
          </Link>
        </li>
      </ul>

      {userReviews?.totalCount > 0 && (
        <div className={s.searchBox}>
          <input
            placeholder={formatMessage(messages.searchReviews)}
            type="text"
            className={cx(s.searchReviewInput, 'searchReviewInputRTL')}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </div>
      )}

      <YourReviews
        data={reviewsData}
        loadMore={loadMore}
        current={current}
        searchKey={searchKey}
        isReviewLoading={isReviewLoading}
      />
    </div>
  );
};

Reviews.propTypes = {
  reviewsData: PropTypes.shape({
    loading: PropTypes.bool,
    formatMessage: PropTypes.any,
    userReviews: PropTypes.object,
    refetch: PropTypes.func
  }),
  loadMore: PropTypes.func.isRequired,
  type: PropTypes.string,
  isReviewLoading: PropTypes.bool,
  intl: PropTypes.object.isRequired
};

Reviews.defaultProps = {
  reviewsData: {
    loading: true
  }
};

export default injectIntl(withStyles(s)(Reviews));